export enum PayoutMethod {
	CAP = "Cap",
	FLOOR = "Floor",
	COLLAR = "Collar",
	NONE = "None",
}
